import TabMethods from "Areas/Sidebar/Documents/tabMethods/tabMethodsContainer";
import { TextWidget } from "Components/optionForm";
import React, { useState } from "react";
import locale from "./methodsSubMenu.locale";
const contextMethodsSubMenuStyle = {
    width: 320,
    height: 380
};
const handleStopPropagation = (evt) => {
    evt.stopPropagation();
};
export default function MethodsSubMenu(props) {
    const [filterText, setFilterText] = useState("");
    return (React.createElement("div", { role: "none", className: "popover-content overflow-hidden grid-rows-auto-1fr", style: contextMethodsSubMenuStyle, onClick: handleStopPropagation },
        React.createElement("div", { className: "p-xxs" },
            React.createElement(TextWidget, { mode: "search", value: filterText, showClearButton: false, placeholder: locale.FILTER_TEXT_PLACEHOLDER, onChange: setFilterText, stylingMode: "filled" })),
        React.createElement(TabMethods, { onBeforeRunMethods: props.onBeforeRunMethods, canAddToQueue: false, bgColorDefault: "transparent", bgColorActive: "gray-050", colorDefault: "text-color", colorHover: "text-color", colorActive: "brand-primary-600", actionIconColor: "gray-400", hasOutsideIndents: false, showHints: false, filterText: filterText, methodsPanelRef: props.methodsPanelRef, runOnItemClick: true })));
}
